import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import axios from 'axios';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';

function SettingBiaya() {

  //Roles
  const ADMIN = 1;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [modalAction, setModalAction] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [settingBiaya, setSettingBiaya] = useState([]);

  // CONTROLLER & LOAD DATA
  const fetchDataSettingBiaya = async () => {
    setIsLoading(true);
    await axios
      .all(
        [
        baseAPI .get(`/v1/csetting`, { headers: { Authorization: `Bearer ${token}` } }),
        ]
      )
      .then((res) => {
        const data = res[0].data.data.dataSetting;        
        setSettingBiaya(data)
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const deleteSettingBiaya = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You will delete this setting data, and you won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);
        await baseAPI
          .delete(`/v1/csetting/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: 'Setting data has been deleted',
              showConfirmButton: false,
              timer: 1500
            })
          })
          .catch((error) => {
            setIsLoading(false);
            Swal.fire({
              icon: 'error',
              title: 'Delete setting data is failed',
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`error ${error}`)
          })
          .finally(() => {
            fetchDataSettingBiaya();
            setIsLoading(false);
          });
      }
    });
  }

  useEffect(() => {
    setIsLoading(true);
    if (users.role === ADMIN) {
      fetchDataSettingBiaya();
    }
  }, [token]);


  const contentTableAction = (id) => {
    if (id !== null) {
      return (
        <div className='text-center'>
          <Link 
            to={`/setting/settingbiaya/editsettingbiaya/${id}`} 
            className="btn btn-primary"
            style={{ backgroundColor: "#6A9C89", marginRight: 10 }}
          >
            <Icon name="Edit" size={16} />
          </Link>
          <button 
            className="btn btn-danger"
            onClick={() => deleteSettingBiaya(id)}
          >
            <Icon name="Trash" size={16} />
          </button>
        </div>
      )
    }
  };

  const userListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'Jenis Biaya',
        id: 'nama',
        width: '10%',
        accessor: 'nama',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.nama_biaya}</div>
      },
      {
        Header: 'Biaya',
        id: 'biaya',
        width: '8%',
        accessor: 'biaya',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{"Rp." + parseFloat(cellInfo.row.original.biaya).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Deskripsi',
        id: 'deskripsi',
        width: '15%',
        accessor: 'deskripsi',
        sortType: 'basic',
        // filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.deskripsi}</div>
      },
      {
        Header: 'Updated At',
        id: 'updatedat',
        width: '8%',
        accessor: 'updatedat',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.updated_at).format('DD/MM/YYYY')}</div>
      },
      {
        Header: 'Action',
        id: 'action',
        width: '8%',
        Cell: (cellInfo) =>
          contentTableAction(
            cellInfo.row.original.id,
          )
      }
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Setting Biaya"
                columns={columns}
                data={settingBiaya}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Setting</Link> /{' '}
                <Link to='/setting/settingbiaya' style={{ color: '#333' }}>Setting Biaya</Link>
              </li>
            </ol>
          </div>

          {/* Tambah setting biaya */}
          <div className='col-auto ml-auto d-print-none'>
            <Link to="/setting/settingbiaya/tambahbiaya">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('tambah biaya')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Plus" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Tambah Biaya</span>
                </div>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )

  const handleView = () => {
    switch (users.role) {
      case ADMIN:
        return userListView();
    }
  };
  
    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      {isLoading ? <LoadingView /> : handleView()}

    </div>

  );

}

export default SettingBiaya;